import { CustomerType, CustomerSearch_Search, OrganizationType } from "@graphql";
import { GeneralSearchData, GeneralSearchStore } from "@search/GeneralSearchStore";

export const searchToFilter = (
  search: GeneralSearchData,
  store: GeneralSearchStore
): CustomerSearch_Search.Variables["filter"] => {
  let {
    lastContact: [to, from]
  } = search;

  if (from && from.toDateString() === new Date().toDateString()) {
    from = null;
  }

  if (to && to.toDateString() === new Date().toDateString()) {
    to = null;
  }

  return {
    areasOfExpertise: search.areasOfExpertiseProfessions
      .selectMany((x) =>
        store.areasOfExp.filter((a) => a.Name === x || a.Profession === x)
      )
      .map((x) => x.Name)
      .unique(),
    fullTextSearch: search.searchType === "extended",
    lastContactDate: { from, to },
    lastContactType: search.lastContactType,
    organizationType: search.organizationType as OrganizationType[],
    responsiblePersonId: search.responsiblePerson,
    systems: search.knownSystems,
    text: search.text,
    region: search.regions,
    type: search.customerType ? toType(search.customerType) : null,
    group: search.customerType ? toGroup(search.customerType) : [],
    callListIds: search.callListIds,
    customerNumbers: search.customerNumbers ? [search.customerNumbers] : null,
    myActivity: search.myActivity,
    journalSystem: search.journalSystem
  };
};

export function toType(customerTypes: any[]): CustomerType[] {
  return customerTypes.filter((type) => Object.values(CustomerType).includes(type));
}

export function toGroup(customerTypes: any[]): string[] {
  // Replace Saknr undergrupp with ""
  return customerTypes
    .filter((type) => !Object.values(CustomerType).includes(type))
    .map((x) => (x === "Saknar undergrupp" ? "" : x));
}

export const NoCustomerGroupOption = {
  label: "Saknar undergrupp",
  value: "Saknar undergrupp",
  parent: CustomerType.Hospital
};

export const NoCustomerGroupOption1 = {
  label: "Saknar undergrupp",
  value: "null"
};
